import { createMiddlewareFromEventsMap } from '@noths/polaris-client-next-redux';

import { GAEventsMap as favouritesGAEventsMap } from 'src/redux/favourites/tracking/eventsMap';
import { GAEventsMap as productImagesCarouselGAEventsMap } from 'src/redux/productImagesCarousel/tracking/eventsMap';
import { GAEventsMap as productInfoGAEventsMap } from 'src/redux/productInfo/eventsMap';
import { GAEventsMap as basketGAEventsMap } from './basket/eventsMap';
import { GAEventsMap as basketTrackingGAEventsMap } from './basket/tracking/eventsMap';
import type { ReduxApplicationState } from './combinedReducer';
import { GAEventsMap as deliveryGAEventsMap } from './delivery/tracking/eventsMap';

export const eventsMap = {
  ...basketGAEventsMap,
  ...basketTrackingGAEventsMap,
  ...deliveryGAEventsMap,
  ...favouritesGAEventsMap,
  ...productImagesCarouselGAEventsMap,
  ...productInfoGAEventsMap,
};

export const GAMiddleware = createMiddlewareFromEventsMap<ReduxApplicationState>(eventsMap);
